export default () => {
  const search = document.querySelector('.property-search');
 

  if (search) {
    const setHeroHeight = () => {
      document.querySelectorAll('.banner_feature, .greeting__slide').forEach((hero, i) => {
        if (document.documentElement.clientWidth > 750) {
          hero.style.height = document.documentElement.clientHeight - search.offsetHeight + 'px';
        } else {
          hero.style.height = document.documentElement.clientHeight * 0.8 + 'px';
        }
      });
    }

    setHeroHeight()
    window.addEventListener('resize', setHeroHeight)
  }
}
